/**
 * LMTM クリエイター サムネの自動スクロール（SP のみ）
 *
 * CSS の transform アニメーションをやめて、スクロールコンテナの scrollLeft を
 * requestAnimationFrame で進める方式にしている。
 *
 * ⚠️ なぜ transform をやめたか
 *   トラックは実測 2520 × 226 CSS px。transform を animation で動かすと、その大きさの
 *   合成レイヤーが確保される（DPR3 の端末でテクスチャおよそ 19.6MB）。
 *   動かしながらの再ラスタライズが追いつかないと**タイルが白いまま1フレーム出る**
 *   ＝「定期的に一瞬きえる」。will-change を外すだけでは足りなかった。
 *   スクロールコンテナなら、ブラウザは見えている範囲＋わずかな余白しか描かない。
 *   New Arrival の帯を background-position 方式にしたのと同じ狙い（docs §6.2）。
 *
 * ⚠️ 折り返しは「1グループぶん進んだら scrollLeft から1グループ分引く」だけ。
 *   トラックには同じグループが2つ入っているので、引いた瞬間も同じ絵が出ていて継ぎ目は出ない。
 */
(function () {
  'use strict';

  function setup(thumbs) {
    var track = thumbs.querySelector('.lmtm-creators__thumbs-track');
    var group = track && track.querySelector('.lmtm-creators__thumbs-group');
    if (!group) return;

    var duration = parseFloat(thumbs.getAttribute('data-lmtm-marquee-duration')) || 24;
    var mqSp = window.matchMedia('(max-width: 749px)');
    var mqReduce = window.matchMedia('(prefers-reduced-motion: reduce)');

    var raf = null;
    var last = 0;
    var pos = 0;
    var held = false;   // 指で触っている間は止める
    var onScreen = true;

    function shouldRun() {
      return mqSp.matches && !mqReduce.matches && onScreen && !held;
    }

    function frame(now) {
      var width = group.offsetWidth;
      if (last && shouldRun() && width > 0) {
        // 1グループぶんを duration 秒で流す
        pos += (width / duration) * ((now - last) / 1000);
        while (pos >= width) pos -= width;
        thumbs.scrollLeft = pos;
      }
      last = now;
      raf = window.requestAnimationFrame(frame);
    }

    function start() {
      if (raf === null) {
        last = 0;
        raf = window.requestAnimationFrame(frame);
      }
    }

    function stop() {
      if (raf !== null) {
        window.cancelAnimationFrame(raf);
        raf = null;
      }
    }

    // 指で触ったら止め、離したらその位置から続ける
    ['pointerdown', 'touchstart'].forEach(function (ev) {
      thumbs.addEventListener(ev, function () { held = true; }, { passive: true });
    });
    ['pointerup', 'pointercancel', 'touchend', 'touchcancel'].forEach(function (ev) {
      thumbs.addEventListener(ev, function () {
        held = false;
        pos = thumbs.scrollLeft;
      }, { passive: true });
    });

    // 画面外では回さない（電池とメモリのため）
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        onScreen = entries[0].isIntersecting;
        if (onScreen) start(); else stop();
      }, { rootMargin: '100px' }).observe(thumbs);
    }

    // 裏に回ったタブでは回さない
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') stop(); else start();
    });

    start();
  }

  function init() {
    document.querySelectorAll('[data-lmtm-marquee-duration]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
